import { render, staticRenderFns } from "./ContainerVueComponentBase.vue?vue&type=template&id=595e782c"
import script from "./ContainerVueComponentBase.vue?vue&type=script&lang=js"
export * from "./ContainerVueComponentBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/graphileon/graphileon/release/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('595e782c')) {
      api.createRecord('595e782c', component.options)
    } else {
      api.reload('595e782c', component.options)
    }
    module.hot.accept("./ContainerVueComponentBase.vue?vue&type=template&id=595e782c", function () {
      api.rerender('595e782c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view-container/ContainerVueComponentBase.vue"
export default component.exports